"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientPaymentHeader = void 0;
const react_1 = require("react");
const React = require("react");
const store_1 = require("client/modules/reporting/store");
const ui_1 = require("client/components/ui");
const mobx_react_1 = require("mobx-react");
// D-002.911 create a new component
let PatientPaymentHeader = class PatientPaymentHeader extends react_1.Component {
    render() {
        const { buttons = [], label = "Search", title } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } }, title && (React.createElement("div", { className: "filter-bar__title", style: { margin: '10px' } },
                React.createElement("div", { className: "filter-bar__title-text" },
                    title,
                    " ",
                    buttons.map(button => button))))),
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
PatientPaymentHeader = __decorate([
    mobx_react_1.observer
], PatientPaymentHeader);
exports.PatientPaymentHeader = PatientPaymentHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/patient-payment/components/patient-payment-header/patient-payment-header.tsx
// module id = 4001
// module chunks = 0